// frontend/src/components/supplier/effectiveCost.js
//
// The price a supplier relation really uses, as one string, for the two places
// a merchant reads it: the item-side Suppliers dialog (ItemSuppliersDialog.jsx)
// and the supplier-side catalog grid's "Cost used" column (pages/
// SupplierCatalog.jsx). The backend prices every row (`effective_cost`,
// `effective_currency_id` — backend/api/serializers.py, `RelationPrice` in
// api/services/supplier_links.py) and this only renders it, so the two screens
// print the same number the same way.

/**
 * @param {object} link  a /api/supplier-catalog-items/ row
 * @param {{formatNumber: Function}} deps
 * @returns {string|null}  null when the row has no effective price at all (no
 *   own cost and no item cost of record) — the caller draws its own dash
 */
export function effectiveCostLabel(link, { formatNumber }) {
  if (link.effective_cost == null) return null;
  // `effective_currency_id` is set whenever `effective_cost` is (both come
  // from one `RelationPrice`), so nothing here substitutes for it.
  return `${formatNumber(link.effective_cost, 2)} ${link.effective_currency_id}`;
}
